//@ts-nocheck
import React from "react";
import styles from "./TemplateSearch.module.scss";
import { FiSearch } from "react-icons/fi";
import { TextFieldWrapper } from "@factorearth/component-library";

function TemplateSearch(props) {
	const { setSearch, color, search } = props;

	function handleSearchChange(e) {
		const value = e.target.value;
		if (value || value === "") {
			setSearch(value);
		}
	}

	return (
		<div
			className={styles.searchWrapper}
			style={{
				backgroundColor: color.background.primary,
				border: `${color.border.primary} 1px solid`,
				color: color.text.primary,
			}}>
			<TextFieldWrapper
				placeholder="Search Templates"
				type="text"
				name="search-bar-top-formgrouplist"
				id="search-bar-top-formgrouplist"
				value={search}
				colorPalette={color}
				onChange={handleSearchChange}
				data-test="tm-search-input"
			/>
			<div className={styles.search_icon} style={{ color: color.text.primary, borderLeft: `solid 1px ${color.text.primary}` }}>
				<FiSearch />
			</div>
		</div>
	);
}

export default TemplateSearch;
